import { ApolloClient, NormalizedCacheObject, useQuery } from "@apollo/client";
import { useMemo } from "react";

import { useChainId } from "lib/chains";

import { createGraphqlClient } from "./apolloClient";
import { CANDLES_QUERY, TOKEN_BY_SYMBOL_QUERY, TOKENS_BY_IDS_QUERY } from "./queries";

let clients: { [chainId: number]: ApolloClient<NormalizedCacheObject> } = {};

function useClient(chainId: number) {
  return useMemo(() => {
    clients[chainId] = clients[chainId] || createGraphqlClient(chainId);
    return clients[chainId];
  }, [chainId]);
}

export function useTokensByIds(ids: string[] | undefined) {
  const { chainId } = useChainId();
  const client = useClient(chainId);

  const skip = !ids || ids.length === 0;
  return useQuery(TOKENS_BY_IDS_QUERY, {
    client,
    variables: { ids: ids ?? [] },
    skip,
  });
}

export function useTokenBySymbol(symbol: string | undefined) {
  const { chainId } = useChainId();
  const client = useClient(chainId);
  const skip = !symbol;

  return useQuery(TOKEN_BY_SYMBOL_QUERY, {
    client,
    variables: { symbol },
    skip,
  });
}

export function useCandles(params: { marketId?: string; interval: string; from: number; to: number }) {
  const { chainId } = useChainId();
  const client = useClient(chainId);
  const { marketId, interval, from, to } = params;
  const skip = !marketId || !interval || !from || !to;

  return useQuery(CANDLES_QUERY, {
    client,
    variables: { marketId, interval, from, to },
    skip,
  });
}
